import React from 'react';
import { Layout } from 'antd';
import Header from '../shared/Header';
import AddWebsiteIndexEntryWizard from '../websiteIndexEntry/wizard/AddWebsiteIndexEntryWizard';
import WebsiteIndexEntrySelector from '../websiteIndexEntry/WebsiteIndexEntrySelector';
import useUrlState from '../../hooks/useUrlState';
import HeaderActions from '../shared/HeaderActions';

const { Content } = Layout;

export default function AddWebsiteIndexEntryPage() {
    const urlState = useUrlState()[0];
    const { w_guid: websiteGuid } = urlState;

    return (
        <Content className="general-layout-content">
            <React.Fragment key={websiteGuid}>
                {websiteGuid && (
                    <Header
                        title={<WebsiteIndexEntrySelector />}
                        rightSideExtra={<HeaderActions websiteGuid={websiteGuid} />}
                    />
                )}
                <AddWebsiteIndexEntryWizard />
            </React.Fragment>
        </Content>
    );
}
